module.exports = __webpack_public_path__ + "static/media/image_one.9bf97160.jpg";